import React, { Component } from 'react';
import { Checkbox } from '@material-ui/core';
import styles from './CustomCheckbox.module.css';

class CustomCheckbox extends Component {
  render() {
    const { ...props } = this.props;

    return (
      <Checkbox
        icon={<span className={styles.checkBoxIcon} />}
        checkedIcon={<span className={styles.checkBoxCheckedIcon} />}
        {...props}
      />
    );
  }
}

export default CustomCheckbox;
